import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  state: {
    tabbarActive: 0,
    appletsId: '',
    openId: '',
    userInfo: null,
    patientList: [],
    hospitalInfo: {},
    careMode: false // 关怀模式状态值
  },
  mutations: {
    changeTabbarActive(state, data) {
      state.tabbarActive = data
    },
    updateInfo(state, data) {
      state[data.name] = data.value
    },

    resetInfo(state, data) {
      state[data.name] = {}
    },
    resetState(state) {
      state.tabbarActive = 0
      state.appletsId = ''
      state.openId = ''
      state.userInfo = null
      state.patientList = []
      state.careMode = false // 重置关怀模式状态值
    },
    switchCareMode(state, value) {
      state.careMode = value // 切换关怀模式状态值
    }
  },
  actions: {},
  modules: {},
  plugins: [createPersistedState()]
})
